import { render, staticRenderFns } from "./TwoYAxisBar.vue?vue&type=template&id=af3539e8&scoped=true"
import script from "./TwoYAxisBar.vue?vue&type=script&lang=js"
export * from "./TwoYAxisBar.vue?vue&type=script&lang=js"
import style0 from "./TwoYAxisBar.vue?vue&type=style&index=0&id=af3539e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af3539e8",
  null
  
)

export default component.exports